import Head from 'next/head'
import { useRouter } from 'next/router'

import { historyUtils } from '@wartek-id/toolbox-helper'
import {
  HeaderBar,
  HeaderBarLeftAction,
  HeaderBarTitle,
} from '@wartek-id/header-bar'

import { isNavigator, isWebview } from 'utils/browser'

import ArrowLeftIcon from 'assets/icons/arrow-left.svg'

export const Header = () => {
  const title = 'Tentang Aplikasi'
  const router = useRouter()
  const isOpenedOnWebview = isNavigator ? isWebview() : true

  return (
    <>
      <Head>
        <title>{title}</title>
      </Head>
      {!isOpenedOnWebview && (
        <HeaderBar fixed variant="default" className="!shadow-none">
          <HeaderBarLeftAction
            onClick={() =>
              historyUtils.backToApp(() => {
                if (window.history.state.idx <= 1) router.push('/home')
                else router.back()
              })
            }
          >
            <ArrowLeftIcon
              width={24}
              height={24}
              className="fill-current text-icon-default"
            />
          </HeaderBarLeftAction>
          <HeaderBarTitle>{title}</HeaderBarTitle>
        </HeaderBar>
      )}
    </>
  )
}
